import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Image2 from "../../assets/images/coupons-offers-img-1.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { FadeLoader } from "react-spinners";
import HmacSHA256 from "crypto-js/hmac-sha256";
import encHex from "crypto-js/enc-hex";
function Checkoutsection() {
  const [activeindex, setTabactiveindex] = useState(1);
  const [isFormvisible, setIsformvisible] = useState(false);
  const [addresslistloading, setAddresslistloading] = useState(true);

  const dispatch = useDispatch();
  const user_id = localStorage.getItem("userId");
  const user_name = localStorage.getItem("userName");
  const emailid = localStorage.getItem("email");
  const phone_number = localStorage.getItem("phone_number");

  const toggleFormVisibility = () => {
    setIsformvisible(true);
    setFirstName(user_name);
    setEmail(emailid);
    setPhonenumber(phone_number);
  };

  const closetoggleFormVisibility = () => {
    setIsformvisible(false);
    setFirstName("");
    setLastName("");
    setAddress("");
    setStatesid("");
    setCityid("");
    setPincode("");
    setEmail("");
    setPhonenumber("");
  };

  const navigation = useNavigate();

  // Fetch address list for user
  const fetchAddressList = () => {
    if (user_id) {
      setAddresslistloading(true); // Set loading to true before making the request
      axios
        .post(apiurl + "address_list", { user_id: user_id })
        .then((res) => {
          setAddresslist(res.data.address);
        })
        .catch((error) => {
          console.error("Error fetching address list:", error);
        })
        .finally(() => {
          setAddresslistloading(false);
        });
    }
  };

  // Handle address removal
  const removeAddress = async (addressid) => {
    await axios
      .post(apiurl + "delete_address", { address_id: addressid })
      .then((res) => {
        fetchAddressList();
        toast.success(res.data.message, { autoClose: 2000 });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const Editaddress = async (addressid) => {
    await axios
      .post(apiurl + "edit_address", {
        address_id: addressid,
      })
      .then((res) => {
        const {
          id,
          first_name,
          last_name,
          address,
          state_id,
          city_id,
          pin_code,
          email_id,
          phone_number,
        } = res.data.address;
        setaddressId(id);
        setFirstName(first_name);
        setLastName(last_name);
        setAddress(address);
        setStatesid(state_id);
        setCityid(city_id);
        setPincode(pin_code);
        setEmail(email_id);
        setPhonenumber(phone_number);
        setIsformvisible(true);
        isEditing(true);
        if (state_id) {
          fetchCity(state_id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAddressList();
  }, [user_id]);

  const [editing, isEditing] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState([]);
  const [statesid, setStatesid] = useState(null);
  const [citys, setCitys] = useState([]);
  const [cityid, setCityid] = useState(null);
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [errors, setErrors] = useState({});
  const [addressId, setaddressId] = useState(null);
  const [addresslist, setAddresslist] = useState([]);

  const validateForm = () => {
    let validationErrors = {};
    if (!firstName.trim())
      validationErrors.firstName = "First name is required";
    if (!lastName.trim()) validationErrors.lastName = "Last name is required";
    if (!address.trim()) validationErrors.address = "Address is required";
    if (!statesid) validationErrors.state = "Please select a state";
    if (!cityid) validationErrors.city = "Please select a city";
    const pincodeStr = String(pincode).trim();
    if (!pincodeStr) validationErrors.pincode = "Pincode is required";
    else if (pincodeStr.length !== 5)
      validationErrors.pincode = "Pincode must be 5 digits";
    const phoneStr = String(phonenumber).trim();
    if (!phoneStr) validationErrors.phonenumber = "Phone number is required";
    else if (phoneStr.length !== 11 && phoneStr.length !== 10)
      validationErrors.phonenumber = "Phone number must be 10 or 11 digits";
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const apiEndpoint = "add_address";

        const requestData = editing
          ? {
              id: addressId,
              first_name: firstName,
              last_name: lastName,
              address: address,
              state_id: statesid,
              city_id: cityid,
              pin_code: pincode,
              email_id: email,
              phone_number: phonenumber,
            }
          : {
              first_name: firstName,
              last_name: lastName,
              address: address,
              state_id: statesid,
              city_id: cityid,
              pin_code: pincode,
              email_id: email,
              phone_number: phonenumber,
              user_id: user_id,
            };

        const response = await axios.post(apiurl + apiEndpoint, requestData);

        if (response.status === 200) {
          toast.success(response.data.message, { autoClose: 2000 });
          fetchAddressList();
          setIsformvisible(false);
          setFirstName("");
          setLastName("");
          setAddress("");
          setStatesid(null);
          setCityid(null);
          setPincode("");
          setEmail("");
          setPhonenumber("");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleStatechange = (e) => {
    const selectedstateid = e.target.value;
    setStatesid(selectedstateid);
    setCitys([]);
    fetchCity(selectedstateid);
  };

  useEffect(() => {
    const fetchstate = async () => {
      await axios
        .post(apiurl + "state", { country_id: 2 })
        .then((response) => {
          setState(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchstate();
  }, []);

  const fetchCity = async (state_id) => {
    await axios
      .post(apiurl + "city", { country_id: 2, state_id: state_id })
      .then((response) => {
        setCitys(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDefaultaddress = async (addressid) => {
    try {
      const response = await axios.post(apiurl + "active_address", {
        address_id: addressid,
        user_id: user_id,
      });

      if (response.status === 200) {
        // Refresh the address list after setting the active address
        setAddresslist([]); // Clear the previous list
        fetchAddressList(); // Re-fetch the updated address list
      }
    } catch (error) {
      console.log(error);
    }
  };

  const {
    items = [],
    grand_total,
    total,
    shipping_amount,
    total_weight,
  } = useSelector((state) => state.cartitems);

  const [cartItems, setCartItems] = useState(items);

  useEffect(() => {
    setCartItems(items.map((item) => ({ ...item })));
  }, [items]);

  const handleClick = () => {
    navigation("/account", { state: { fromCart: true } });
  };

  const [couponsList, setCouponsList] = useState(() => {
    const initial = localStorage.getItem("couponDetails");
    return initial ? JSON.parse(initial) : null;
  });

  useEffect(() => {
    // Listener function
    const handleCouponChange = () => {
      const updatedCoupon = localStorage.getItem("couponDetails");
      if (updatedCoupon) {
        setCouponsList(JSON.parse(updatedCoupon));
      } else {
        setCouponsList(null);
      }
    };

    // Add custom event listener
    window.addEventListener("couponChanged", handleCouponChange);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("couponChanged", handleCouponChange);
    };
  }, []);

  // useEffect(() => {
  //   const couponDetails = localStorage.getItem("couponDetails");
  //   if (couponDetails) {
  //     setCouponsList(JSON.parse(couponDetails));
  //   }
  // }, []);

  const clearCoupon = () => {
    localStorage.removeItem("couponDetails");
    window.location.reload();
  };

  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const itemsd = useSelector((state) => state.cartitems.items);

  const paymentsuccess = async () => {
    if (!selectedAddressId) {
      toast.error("Please Select the address", { autoClose: 2000 });
      return;
    } else if (!user_id) {
      toast.error("Confirm you have logged in", { autoClose: 2000 });
      return;
    }

    try {
      const finalAmount = parseFloat(
        (couponsList && couponsList.total
          ? couponsList.total
          : grand_total
        ).replace(/,/g, "")
      );

      const orderResponse = await axios.post(apiurl + "place_order", {
        user_id: user_id,
        address_id: selectedAddressId,
        product_details: itemsd,
        coupon_id: couponsList?.coupon_id || null,
        coupon_discount: couponsList?.coupon_amount || null,
        total: total,
        delivery_partner: null,
        shipping_amount: shipping_amount,
        grand_total: finalAmount,
        weight: total_weight,
        order_through: "web application",
      });

      if (orderResponse.status === 200) {
        // const { order_id } = orderResponse.data;
        // const merchantId = 153174081261157;
        // const secretKey = "SK-7You9q3SmCbKRto5gPGH";
        // const amount = finalAmount;
        // const detail = "web+application";
        // const email = "karthik@gmail.com";
        // const phone = 6382538986;

        // const name = "karthik";
        // const hashString = secretKey + detail + amount + order_id;
        // const hash = HmacSHA256(hashString, secretKey).toString(encHex);
        // const senangpayUrl = `https://app.senangpay.my/payment/${merchantId}/?detail=${detail}&amount=${amount}&hash=${hash}&order_id=${order_id}&phone=${phone}&email=${encodeURIComponent(
        //   email
        // )}&name=${name}`;
        // console.log(senangpayUrl);
        window.location.href = orderResponse.data.url;
      } else {
        toast.error("There was an error while placing your order.", {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error while placing the order:", error);
      toast.error(
        "An error occurred while placing your order. Please try again later.",
        { autoClose: 2000 }
      );
    }
  };

  useEffect(() => {
    if (Array.isArray(addresslist) && addresslist.length > 0) {
      const activeAddress = addresslist.find(
        (item) => item.active_status === 1
      );
      if (activeAddress) {
        setSelectedAddressId(activeAddress.id);
      }
    }
  }, [addresslist]);

  return (
    <section className="check-out-section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 left_col">
            <div className="address-inner-box">
              {!isFormvisible ? (
                <div className="add_btn_box">
                  <button className="add_btn" onClick={toggleFormVisibility}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                  <h6>Add New Address</h6>
                </div>
              ) : (
                <div className="add_address_inner_box">
                  <h5>{editing ? "Edit Address" : "Add new Address"}</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>First name</label>
                          <input
                            className="form-control"
                            name="first_name"
                            type="text"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[a-zA-Z\s]*$/.test(value)) {
                                setFirstName(value);
                              }
                            }}
                            value={firstName}
                          />
                          {errors.firstName && (
                            <small className="text-danger">
                              {errors.firstName}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>Last name</label>
                          <input
                            className="form-control"
                            name="last_name"
                            type="text"
                            value={lastName}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^[a-zA-Z\s]*$/.test(value)) {
                                setLastName(value);
                              }
                            }}
                          />
                          {errors.lastName && (
                            <small className="text-danger">
                              {errors.lastName}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="mt-2">
                          <label>Address</label>
                          <textarea
                            className="form-control"
                            name="address"
                            onChange={(e) => setAddress(e.target.value)}
                            value={address}
                          ></textarea>
                          {errors.address && (
                            <small className="text-danger">
                              {errors.address}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>State</label>
                          <select
                            className="form-control"
                            name="state"
                            onChange={handleStatechange}
                            value={statesid || ""}
                          >
                            <option value="">Select State</option>
                            {state && state.length > 0
                              ? state.map((data, index) => {
                                  return (
                                    <option key={index} value={data.id}>
                                      {data.state_name}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                          {errors.state && (
                            <small className="text-danger">
                              {errors.state}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>City</label>
                          <select
                            name="city"
                            className="form-control"
                            onChange={(e) => setCityid(e.target.value)}
                            value={cityid || ""}
                          >
                            <option value="">Select City</option>
                            {citys.length > 0 ? (
                              citys.map((cityItem, index) => (
                                <option key={index} value={cityItem.id}>
                                  {cityItem.city_name}
                                </option>
                              ))
                            ) : (
                              <option value="">No cities available</option>
                            )}
                          </select>
                          {errors.city && (
                            <small className="text-danger">{errors.city}</small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>Postal code</label>
                          <input
                            className="form-control"
                            name="pin_code"
                            type="text"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setPincode(value);
                              }
                            }}
                            value={pincode}
                            maxLength={5}
                          />
                          {errors.pincode && (
                            <small className="text-danger">
                              {errors.pincode}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8 col-md-4">
                        <div className="mt-2">
                          <label>Email</label>
                          <input
                            className="form-control"
                            name="email_id"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <div className="mt-2">
                          <label>Phone Number</label>
                          <input
                            className="form-control"
                            name="phone_number"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setPhonenumber(value);
                              }
                            }}
                            value={phonenumber}
                            type="text"
                            maxLength={11}
                          />
                          {errors.phonenumber && (
                            <small className="text-danger">
                              {errors.phonenumber}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 submit_btn">
                      <button className="btn_1">Submit</button>
                      <button
                        className="btn_2"
                        onClick={closetoggleFormVisibility}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {!isFormvisible ? (
                <>
                  <div className="address_list_inner_box mt-3">
                    {addresslistloading ? (
                      <div
                        className="col-12 d-flex"
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "30px",
                        }}
                      >
                        <FadeLoader size={50} />
                      </div>
                    ) : addresslist && addresslist.length > 0 ? (
                      addresslist.map((item, index) => {
                        return (
                          <div className="list_inner_box_one" key={index}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "start",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "10px",
                                }}
                              >
                                <div>
                                  <input
                                    type="radio"
                                    name="address"
                                    id={`address${item.id}`}
                                    checked={
                                      selectedAddressId === item.id ||
                                      item.active_status === 1
                                    } // Mark active address
                                    onChange={() => {
                                      setSelectedAddressId(item.id); // Set the selected address ID
                                      setDefaultaddress(item.id); // Call setDefaultaddress to set as default
                                    }}
                                  />
                                </div>
                                <div style={{ marginRight: "20px" }}>
                                  <h6
                                    style={{
                                      display: "inline-block",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    Deliver to {item.first_name}
                                  </h6>
                                  <p
                                    className="mb-0 pb-2"
                                    style={{
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.address}
                                    <br />
                                    <b>{item.phone_number}</b>
                                  </p>
                                </div>
                              </div>

                              <div className="edit_box">
                                <button
                                  className="btn_3"
                                  style={{ padding: "2px 20px" }}
                                  onClick={() => Editaddress(item.id)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn_3"
                                  style={{ padding: "2px 20px" }}
                                  onClick={() => removeAddress(item.id)}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p>No addresses available.</p> // Show when address list is empty
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="col-lg-4 right_col">
            <div className="main-box">
              <div className="inner-box">
                <table className="table">
                  <tr>
                    <td className="order_summary_heading">Order summary</td>
                    <td>
                      Cart Value ({items.length > 0 ? items.length : 0} items)
                    </td>
                  </tr>
                </table>

                <div className="coupons_offer_box" onClick={handleClick}>
                  <div className="left_box">
                    <img
                      src={Image2}
                      style={{ width: "24px", height: "24px" }}
                      alt="img"
                    />
                    <div>
                      <h6 className="mb-0">Coupons & Offer</h6>
                      <span>View More Coupons</span>
                    </div>
                  </div>
                  <div>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </div>
                <table className="w-100">
                  <tr className="mt-2">
                    <td>Sub Total</td>
                    <td>RM {total}</td>
                  </tr>
                  <tr className="mt-2">
                    <td>Shipping Amount</td>
                    <td>RM {shipping_amount}</td>
                  </tr>
                </table>
                {couponsList && couponsList.code ? (
                  <div className="mt-3 text-end mb-2">
                    <button className="btn_1_1" onClick={() => clearCoupon()}>
                      Clear Coupon
                    </button>
                  </div>
                ) : null}
                {couponsList && couponsList.code ? (
                  <div className="coupon-details mt-3">
                    <table className="w-100">
                      <tr>
                        <td>Coupon Code:</td>
                        <td>{couponsList.code}</td>
                      </tr>
                      <tr>
                        <td>Coupon Amount:</td>
                        <td>
                          {parseFloat(couponsList.coupon_amount).toFixed(2)}
                        </td>
                      </tr>
                    </table>
                  </div>
                ) : null}
              </div>
              <div className="inner-box-two">
                <h6 className="mb-0">Total</h6>
                RM {couponsList ? couponsList.total : grand_total}
              </div>
              <div className="btn_box mt-3">
                <button onClick={() => paymentsuccess()} className="btn_1">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Checkoutsection;
